/* eslint-disable jsx-a11y/anchor-is-valid */
import moment from 'moment';
import React from 'react';
import { setAsRead } from 'store/modules/new_notification_store/actions';
import { useDispatch, useSelector } from 'react-redux';
import companyId from 'services/company_id';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { Container } from './styles';

interface NotificationItemsInterface {
  notification: any;
}

const NotificationItems: React.FC<NotificationItemsInterface> = ({ notification }) => {
  const dispatch = useDispatch();

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const message = () => {
    const notification_reasons: { [key: number]: string } = {
      1: 'licitacao',
      2: 'acompanhamento',
      3: 'edital',
    };

    if (
      notification.actable_type === 'Notification::UpdatedBidding' &&
      notification.specific.bidding
    ) {
      let editalNumber = notification.specific.bidding.edital.slice(
        notification.specific.bidding.edital.indexOf('/') + 1,
      );
      editalNumber =
        !editalNumber || editalNumber === 'NÃO INFORMADO' ? (
          'não informado'
        ) : (
          <strong>{editalNumber}</strong>
        );

      let message = null;
      let modality = notification.specific?.bidding?.modality?.nome;
      const { notification_reason_id } = notification.specific;
      modality = modality === 'Não Informado' ? 'licitação' : <strong>{modality}</strong>;
      switch (notification_reasons[notification_reason_id]) {
        case 'licitacao':
          message = (
            <p>
              O aviso de {modality} de número {editalNumber} para o órgão{' '}
              <strong>{notification.specific.bidding.public_body?.nome}</strong> foi atualizado.
            </p>
          );
          break;
        case 'acompanhamento':
          message = (
            <p>
              O aviso de {modality} de número {editalNumber} para o órgão{' '}
              <strong>{notification.specific.bidding.public_body?.nome}</strong> teve um novo
              acompanhamento publicado.
            </p>
          );
          break;
        case 'edital':
          message = (
            <p>
              O aviso de {modality} de número {editalNumber} para o órgão{' '}
              <strong>{notification.specific.bidding.public_body?.nome}</strong> está com novos
              documentos disponíveis.
            </p>
          );
          break;
        default:
          break;
      }

      return message;
    }

    if (notification.actable_type === 'Notification::Campaign') {
      return <p>{notification.specific.title}</p>;
    }

    if (notification.actable_type === 'Notification::ManagementBidding') {
      return (
        <p>
          Task #{notification.specific.task_id} - Você foi atribuído a uma nova tarefa no Gerenciar
          Licitações. Resumo: <strong>{notification.specific.summary}</strong>
        </p>
      );
    }

    if (notification.actable_type === 'Notification::Documents') {
      return (
        <p>
          O documento <strong>{notification.specific.document_name}</strong> encontra-se pendente.
        </p>
      );
    }

    return null;
  };

  const onClickHandler = async () => {
    try {
      await dispatch(setAsRead({ id: notification.id }));

      switch (notification.actable_type) {
        case 'Notification::UpdatedBidding':
          window.location.href = `/biddings/${notification.specific.bidding_id}`;
          break;
        case 'Notification::Campaign':
          window.location.href = notification.specific.url;
          break;
        case 'Notification::ManagementBidding':
          window.location.href = `/minhas_licitacoes/management/${
            notification.specific.task.bidding_id
          }/${companyId(profile)}`;
          break;
        case 'Notification::Documents':
          window.location.href = `/documentos`;
          break;
        default:
          break;
      }
    } catch (error) {
      console.error('Erro ao marcar a notificação como lida:', error);
    }
  };

  const calculateDateDifference = (date: string) => {
    const updatedDate = moment(new Date(date));
    const currentDate = moment();

    return currentDate.diff(updatedDate, 'minutes');
  };

  const isLessThanOneHour = (minutes: number) => minutes < 60;
  const isLessThanEightHours = (minutes: number) => minutes < 60 * 8;
  const getDateInHour = (minutes: number) => Math.floor(minutes / 60);

  const mountDateMessage = () => {
    const calculatedDate = calculateDateDifference(notification.created_at);

    if (isLessThanOneHour(calculatedDate)) {
      return `Há ${calculatedDate} minutos.`;
    }

    if (isLessThanEightHours(calculatedDate)) {
      return `Há ${getDateInHour(calculatedDate)} hora(s).`;
    }

    return `Em ${moment(notification.created_at).format('DD/MM/YYYY')}`;
  };

  return (
    <Container>
      <div className="list-group list-group-flush">
        <a
          href="#"
          className={`list-group-item list-group-item-action ${
            notification.read ? '' : 'new-notification'
          }`}
          onClick={onClickHandler}
        >
          <p>{message()}</p>
          <small className="date-notification">
            <em>{mountDateMessage()}</em>
          </small>
        </a>
      </div>
    </Container>
  );
};

export default NotificationItems;
